import { useQuery } from "@tanstack/react-query";
import type { RollMaterial } from "../models/RollMaterial";
import { getRollMaterials } from "../repositories/RollMaterialsRepository";

export const ROLL_MATERIALS_QUERY_KEYS = {
	all: ["rollMaterials"] as const,
	list: () => ["rollMaterials", "list"] as const,
	byId: (id: number | null) => ["rollMaterials", "detail", id] as const,
};

export const useRollMaterials = () => {
	const query = useQuery<RollMaterial[], Error>({
		queryKey: ROLL_MATERIALS_QUERY_KEYS.list(),
		queryFn: () => getRollMaterials(),
	});

	return {
		rollMaterials: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
